import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import { LOAD_CALCULATIONS_DATA } from "../../store/application-actions";
import Err from "@Broker/@Routes/error";
import CompleteApplicationDropdown from "./complete-application-dropdown.vue";
import { isEmpty, kebabCase } from "lodash";
import ValueSection from "./value-section.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationCalculations",
  components: {
    CompleteApplicationDropdown,
    ValueSection
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    },
    readonly: Boolean
  },
  computed: _objectSpread(_objectSpread({}, mapState("ApplicationStore", {
    calculations(state) {
      return state.calculations;
    },
    explanations(state) {
      return state.calculatedValues.legend;
    }
  })), {}, {
    calculationExplanationPath() {
      const {
        agentUsername,
        clientUsername,
        applicationId
      } = this;
      return `#/widgets/applications/${applicationId}/client/${clientUsername}/agent/${agentUsername}/calculation-explanations`;
    },
    firstQualifyingMortgageSection() {
      return "calculators.QUALIFYING_DETAILS_FOR_FIRST_MORTGAGE";
    },
    firstMortgageExists() {
      var _context;
      return _findInstanceProperty(_context = this.calculations).call(_context, ({
        $key_sectionName: sectionNameKey
      }) => sectionNameKey === this.firstQualifyingMortgageSection);
    }
  }),
  mounted() {
    this.LOAD_CALCULATIONS_DATA({
      clientUsername: this.clientUsername,
      applicationId: this.applicationId
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [LOAD_CALCULATIONS_DATA])), {}, {
    getValueText(value, type) {
      const {
        formatMoneyValueLong,
        parsePercentageDecimal
      } = this.$options.filters;
      if (value === null) return "N/A";
      if (type === "number") return value.toString();
      return type === "money" ? formatMoneyValueLong(value) : parsePercentageDecimal(value);
    },
    async reCalculate() {
      const submitButton = $(this.$refs.reCalculate);
      try {
        submitButton.animateButton().animate("start");
        await this.LOAD_CALCULATIONS_DATA({
          clientUsername: this.clientUsername,
          applicationId: this.applicationId
        });
        await submitButton.animateButton().animate("finish");
      } catch (e) {
        Err.handle(e);
        submitButton.animateButton().animate("finish", "failed");
      }
    },
    nameToKebab(name) {
      return kebabCase(name);
    },
    explanationExists(calculationValue) {
      if (!this.explanations || !this.firstMortgageExists) return false;
      const {
        $key_name: keyName = "",
        hyperlink = {}
      } = calculationValue;
      const isFirstMortgageSection = !isEmpty(hyperlink) && !isEmpty(hyperlink.type) && hyperlink.mortgageType === "first";
      const isLTV = keyName === "calculators.LTV";
      const isValidSection = isFirstMortgageSection || isLTV;
      const explanationKey = isValidSection ? hyperlink.type.toLowerCase() : "";
      const explanationFilled = !isEmpty(this.explanations[explanationKey]);
      return isValidSection && explanationFilled;
    },
    getPopoverWindowOptions(calculationValue) {
      const {
        hyperlink = {}
      } = calculationValue;
      if (isEmpty(hyperlink) || isEmpty(hyperlink.type)) return {};
      const calculation = hyperlink.type.toLowerCase();
      return {
        url: `${this.calculationExplanationPath}/${calculation}`,
        width: 460,
        height: 700
      };
    }
  })
});